const IS_LOCAL = window.location.hostname === 'localhost';

const IS_DEV = [
    'http://localhost:3000',
    'https://buying-dev.bestseller.com',
    'https://ambassador.buying01-dev.k8s.bestcorp.net',
].includes(window.location.origin);

const IS_TEST = [
    'https://buying-test.bestseller.com',
    'https://ambassador.buying01-test.k8s.bestcorp.net',
].includes(window.location.origin);

const IS_PROD = [
    'https://buying.bestseller.com',
    'https://ambassador.buying01-prod.k8s.bestcorp.net',
].includes(window.location.origin);

type Env = 'dev' | 'prod' | 'test';

// Since we want ENV to be a const, we use the env let to determine the value of ENV
let env: Env = 'dev';
if (IS_PROD) {
    env = 'prod';
} else if (IS_TEST) {
    env = 'test';
}
const ENV = env;

export { ENV, IS_DEV, IS_LOCAL, IS_PROD, IS_TEST };
